const motionComponentSymbol = Symbol.for("motionComponentSymbol");
export {
  motionComponentSymbol
};
//# sourceMappingURL=symbol.js.map
